import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import Chatbot from "./Chatbot";

/**
 * MainLayout - Persistent layout wrapper for all public pages
 * Provides consistent navigation, footer, and floating components
 */
const MainLayout = ({ children, showFooter = true }) => {
  return (
    <div className="min-h-screen bg-slate-950">
      {/* Persistent Navbar - Fixed at top */}
      <Navbar />
      
      {/* Main content with top padding for fixed navbar */}
      <main className="pt-[75px]">
        {children}
      </main>
      
      {/* Footer */}
      {showFooter && <Footer />}
      
      {/* Floating components */}
      <WhatsAppButton />
      <Chatbot />
    </div>
  );
};

export default MainLayout;
